import React from 'react';
import { BackButton } from '@dynamika-shared/ui/BackButton/BackButton';
import { formatDate } from './common/renderers';

export type SupportSubjectDetailHeaderProps = {
  onBack: () => void;
  subject: {
    patientCode?: string;
    patientDob?: string;
    cohortName?: string;
    siteCode?: string;
  };
};

export const SupportSubjectDetailHeader: React.FC<
  SupportSubjectDetailHeaderProps
> = ({ onBack, subject }) => {
  return (
    <header className='mini:py-2 flex w-full items-center justify-between py-2'>
      <div className='flex items-center gap-[.5rem]'>
        <BackButton action={onBack} text='Back' />
        <h2 className='mini:text-[2.4rem] mini:leading-[2.8] ml-[10px] truncate text-left text-[3.6rem] font-semibold leading-[4.4rem] tracking-normal'>
          {subject.patientCode}
        </h2>
      </div>

      <div className='flex items-center gap-2'>
        <div className='flex items-center gap-1'>
          <span className='font-poppins text-dimGray text-lg font-light leading-5'>
            Date of Birth:
          </span>
          <span className='font-poppins text-lg font-medium leading-5'>
            {formatDate(subject.patientDob)}
          </span>
        </div>

        <div className='w-[2px] h-2.5 rounded-[8px] bg-waterLight' />

        <div className='flex items-center gap-1'>
          <span className='font-poppins text-dimGray text-lg font-light leading-5'>
            Cohort:
          </span>
          <span className='font-poppins text-lg font-medium leading-5'>
            {subject.cohortName}
          </span>
        </div>

        <div className='w-[2px] h-2.5 rounded-[8px] bg-waterLight' />

        <div className='flex items-center gap-1'>
          <span className='font-poppins text-dimGray text-lg font-light leading-5'>
            Site Code:
          </span>
          <span className='font-poppins text-lg font-medium leading-5'>
            {subject.siteCode}
          </span>
        </div>
      </div>
    </header>
  );
};

export default SupportSubjectDetailHeader;
